import styled, { css, keyframes } from 'styled-components';
import { VisorEmblemLogo } from './visor-emblem-logo';
import { primaryColor, textColorDark } from '../utils/variables';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.55; }
`;

const progress = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(250%); }
`;

export const BootstrapScreen = styled.div<{ $overlay?: boolean; $fading?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  padding: 1.5rem;
  background: var(--login-background);
  color: ${textColorDark};
  transition: opacity 0.45s ease;

  ${({ $overlay }) =>
    $overlay &&
    css`
      position: fixed;
      inset: 0;
      z-index: 10000;
      min-height: 100dvh;
    `}

  ${({ $fading }) =>
    $fading &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`;

export const BootstrapLogo = styled(VisorEmblemLogo)`
  height: 40px;
  width: auto;
  margin-bottom: 2rem;
  color: ${primaryColor};
  animation: ${pulse} 2s ease-in-out infinite;
`;

export const BootstrapTitle = styled.h1`
  margin: 0;
  font-size: clamp(1.75rem, 5vw, 2.5rem);
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  color: ${textColorDark};
`;

export const BootstrapSubtitle = styled.p`
  margin: 1rem 0 0;
  font-size: 1rem;
  text-align: center;
  color: var(--muted-foreground);
`;

export const BootstrapProgressTrack = styled.div`
  margin-top: 2rem;
  width: min(240px, 70vw);
  height: 3px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.08);
  overflow: hidden;
`;

export const BootstrapProgressBar = styled.div`
  width: 40%;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, ${primaryColor}, #6366f1);
  animation: ${progress} 1.4s ease-in-out infinite;
`;
